import { DetailedInsight } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { InsightCardDetails } from '~/components/insight-card-details/InsightCardDetails';
import { useFlags } from '~/stores/use-flags/useFlags';

import * as S from './InsightSummary.styles';
import { TrackScenarioInsightButton } from './track-scenario-insight-button/TrackScenarioInsightButton';

export interface InsightSummaryProps {
  insight: DetailedInsight;
  isFixedIncome: boolean;
}

export const InsightSummary = ({
  insight,
  isFixedIncome,
}: InsightSummaryProps) => {
  const { t } = useTranslation('insights');
  const isAlertsFeatureEnabled = useFlags(state =>
    state.getFeatureFlagState('alerts')
  );

  return (
    <S.InsightSummaryRoot data-testid="insight-summary">
      <S.TitleRow>
        <S.Title>{t('insights:drawer.insightAlert')}</S.Title>
        {isAlertsFeatureEnabled && (
          <TrackScenarioInsightButton insightId={insight.id} />
        )}
      </S.TitleRow>
      <S.InsightCardWrapper>
        <InsightCardDetails
          qualityStars={insight.metadata.stars}
          median={insight.metadata.median_return}
          horizon={insight.metadata.horizon}
          isFixedIncome={isFixedIncome}
        />
      </S.InsightCardWrapper>
      {isAlertsFeatureEnabled && (
        <S.FooterText>{t('insights:drawer.insightWillBeTracked')}</S.FooterText>
      )}
    </S.InsightSummaryRoot>
  );
};
